import Polyline from "./polyline";
class wallPolyline extends Polyline {
  constructor(obj){
    super(obj)

    const { closure, diffHeight, image, color, opacity, colorHL, opacityHL } =obj

    this._highlightOptions = {
      ...this._highlightOptions,
      materialOptions:{
        color: colorHL ? colorHL : '#ff0000',
        opacity: opacityHL !== null ? opacityHL : 1.0
      }
    }
    this._styleOptions = {
      ...this._styleOptions,
      closure: closure || false,
      diffHeight: diffHeight !== null ? diffHeight : 800,
      materialType: mars3d.MaterialType.LineFlow,
      materialOptions:{
        image: image,
        color: color ? color : '#ffff00',
        mixt: true,
        speed: 10,
        axisY: true,
        opacity: opacity !== null ? opacity : 1.0
      },
      highlight: this._highlight ? this._highlightOptions : {},
    }
    this._symbol = {
      ...this._symbol,
      type: "wallP",
      styleOptions: this._styleOptions
    }
    this._initObj = {
      ...this._initObj,
      symbol: this._symbol
    }
  }
}

export default wallPolyline